import { useParams } from 'react-router-dom';

export type PageAdminInterviewRouteParams = {
  interviewId: string;
};

export const useAdminInterviewPageParams = () => {
  return useParams<PageAdminInterviewRouteParams>() as PageAdminInterviewRouteParams;
};
